var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('filter-followers-block',{attrs:{"module-name":"influencerDiscovery","is-filter-applied":_vm.isFilterApplied,"max-value":10000000},on:{"submit":_vm.handleSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }